/**
 * @file Manages styles for Header atom.
 * @author kkumari
 */
import { css } from 'styled-components';
export default css(["margin:0;display:table;"]);